// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_f2-0";